export const MAX_QTY = 100;
